import React from 'react';
import { Box, Flex, Circle, Text, useTheme } from 'native-base';
import { Platform } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { DEVICE_WIDTH } from '../Constants';
import { addInlineStyleToMentionBlot, displayTime, getSourceHTML } from '../utils/helpers';
import { useDomParser } from '../hooks/useDomParser';

// moved this outside of function component body to prevent it from affecting performance
const tagsStyles = {
  p: {
    margin: 0,
    padding: 0
  }
};
const PrivateMessage = _ref => {
  let {
    pmsg
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const {
    created_at,
    name: friendlyUsername,
    yours
  } = pmsg;
  let sourceHTML = getSourceHTML(pmsg, colors); // pmsg.cooked will be used
  const {
    getParser,
    normalizeImages,
    displayAtMentions
  } = useDomParser();

  // parse/normalize markup
  const parser = getParser();
  if (parser) {
    sourceHTML = normalizeImages(parser, sourceHTML, DEVICE_WIDTH);
    sourceHTML = displayAtMentions(parser, sourceHTML);
    sourceHTML = addInlineStyleToMentionBlot(parser, sourceHTML, colors);
  }

  /* if (yours) => Circle will be positioned to the right
  replaced all &&s with ternary as yours && (something) always fell to false, thus crashing the app
  */
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    px: 4,
    bg: colors.privateMessage.box.bg,
    ml: yours ? 6 : 2,
    my: 1,
    w: yours ? '85%' : '90%'
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: yours ? 'row-reverse' : 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Box, {
    h: '100%'
  }, /*#__PURE__*/React.createElement(Circle, {
    size: '32px',
    bg: pmsg.user_id < 0 ? colors.privateMessage.user.notFound : colors.privateMessage.user.found,
    ml: yours ? '4' : '2',
    mt: 2
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.privateMessage.user.name
  }, friendlyUsername.charAt(0).toUpperCase()))), /*#__PURE__*/React.createElement(Flex, {
    direction: 'column',
    justifyContent: 'center',
    ml: 2,
    p: 3,
    width: '100%',
    borderWidth: 1,
    borderRadius: 10,
    borderColor: yours ? colors.privateMessage.yours.border : colors.privateMessage.notYours.border,
    bg: yours ? colors.privateMessage.yours.bg : colors.privateMessage.notYours.bg
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'sm',
    fontWeight: 'bold',
    mb: 1
  }, friendlyUsername), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.privateMessage.content
  }, /*#__PURE__*/React.createElement(RenderHtml, {
    defaultTextProps: {
      selectable: true
    },
    contentWidth: Platform.OS === 'web' ? null : DEVICE_WIDTH,
    tagsStyles: tagsStyles
    // source={{html: cooked}}
    ,
    source: {
      html: sourceHTML
    }
  })), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.privateMessage.created
  }, displayTime(created_at), " ago")))));
};
export default PrivateMessage;
//# sourceMappingURL=PrivateMessage.js.map